export default __webpack_public_path__ + "files/1_3_2_2_Best_practice_examples_of_bio_based_solutions_with_replicability_potential.docx";